<template>
	<div ref="page">
		<!-- swiper 插件 轮播图 -->
		<div class="banner">
			<img :src="pageData.banner" alt="">
			<div class="title">{{pageData.title}}</div>
		</div> 

		<!-- 内容容器 -->
		<div class="content-wrapper">
			<section class="data0" ref="data0">
				<div class="content">

          <div class="left">
            <div class="item" @click="openPage(pageData.data0.lists[0])" v-if="pageData.data0.lists.length >= 1">
              <img :src="pageData.data0.lists[0].imgUrl" alt="">
              <div class="text-box">
                <div class="title">{{pageData.data0.lists[0].title}}</div>
              </div>
              <div class="date">
                <div class="date1">{{handleSliceStr(pageData.data0.lists[0].updateTime, 8, 10) > 10 ? handleSliceStr(pageData.data0.lists[0].updateTime, 8, 10) : handleSliceStr(pageData.data0.lists[0].updateTime, 9, 10) }}</div>
                <div class="date2">{{handleSliceStr(pageData.data0.lists[0].updateTime, 0, 7)}}</div>
              </div>
              <!-- <div class="date">{{pageData.data0.lists[0].updateTime}}</div> -->
              <!-- <div class="title">{{pageData.data0.lists[0].title}}</div>
              <div class="date">{{pageData.data0.lists[0].updateTime}}</div> -->
            </div>
          </div>
          <div class="right">
            <div class="item" @click="openPage(pageData.data0.lists[1])" v-if="pageData.data0.lists.length >= 2">
              <img :src="pageData.data0.lists[1].imgUrl" alt="">
              <div class="text-box">
                <div class="title">{{pageData.data0.lists[1].title}}</div>
              </div>
              <div class="date">
                <div class="date1">{{handleSliceStr(pageData.data0.lists[1].updateTime, 8, 10) > 10 ? handleSliceStr(pageData.data0.lists[1].updateTime, 8, 10) : handleSliceStr(pageData.data0.lists[1].updateTime, 9, 10) }}</div>
                <div class="date2">{{handleSliceStr(pageData.data0.lists[1].updateTime, 0, 7)}}</div>
              </div>
              <!-- <div class="title">{{pageData.data0.lists[1].title}}</div>
              <div class="date">{{pageData.data0.lists[1].updateTime}}</div> -->
            </div>
            <div class="item" @click="openPage(pageData.data0.lists[2])" v-if="pageData.data0.lists.length >= 3">
              <img :src="pageData.data0.lists[2].imgUrl" alt="">
              <div class="text-box">
                <div class="title">{{pageData.data0.lists[2].title}}</div>
              </div>
              <div class="date">
                <div class="date1">{{handleSliceStr(pageData.data0.lists[2].updateTime, 8, 10) > 10 ? handleSliceStr(pageData.data0.lists[2].updateTime, 8, 10) : handleSliceStr(pageData.data0.lists[2].updateTime, 9, 10) }}</div>
                <div class="date2">{{handleSliceStr(pageData.data0.lists[2].updateTime, 0, 7)}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="lists">
            <template v-for="(item, index) in pageData.data0.lists">
              <div class="item" @click="openPage(`details/busniess/${item.id}`)" :class="{'left': index==0}" :key="index" v-if="index < 3">
                <img :src="item.imgUrl" alt="">
                <div class="title">{{item.title}}</div>
                <div class="date">{{item.updateTime}}</div>
              </div>
            </template>
          </div> -->
				</div>
			</section>
      <section class="data1" ref="data1">
				<div class="content" v-if="pageData.data0.lists.length > 3">
          <div class="infinite-list-wrapper" ref="lists" style="overflow:auto">
            <ul
              class="lists"
              v-infinite-scroll="casePage"
              infinite-scroll-disabled="disabled">
              <template v-for="(item, index) in pageData.data0.lists">
                <div class="item" :key="index" v-if="index >= 3">
                  <img :src="item.imgUrl" alt="">
                  <div class="text-box">
                    <div class="title">{{item.title}}</div>
                    <div class="date">{{item.updateTime}}</div>
                    <div class="desc-text">
                      <div class="desc">
                        <template v-for="(item, index) in handleBrArr(item.desc)">
                          <div :key="index" v-if="item">
                            {{item}}
                          </div>
                        </template>
                      </div>
                      <!-- <div class="desc">{{item.desc}}</div> -->
                      <!-- <div class="more-box2" @click="openPage(item)">
                        <img src="/static/images/btn_more_02_nor@2x.png" alt="">
                        <div class="laber">查看详情</div>
                      </div> -->
                      <div class="more-box" @click="openPage(item)">
                        查看详情
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </ul>
            <div class="more-tip" v-if="!lastPage" @click="casePage()">点击加载更多</div>
            <div class="more-tip" v-if="noMore">没有更多了</div>
          </div>
				</div>
			</section>


		</div>
	</div>
</template>

<script>
  import mixins from '@/mixins';
  import Swiper from 'swiper';
	import { casePage, companyItemList, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	export default {
    name: 'NewBusiness',
    mixins: [mixins],
		props: {},
		components: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'new',
				pageData: {
					banner: '',
					title: '企业动态',
					// 我的服务
					data0: {
            content: '',
            lists: [],
          },
				},
				data2Index: 0,
        serviceIndex: 0,
        listLoading: false,
        isLoading: false,
        noMore: false,
        pageNum: 1,
        lastPage: false,
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'new');
      this.init();
		},
		computed: {
      disabled () {
        return this.listLoading || this.noMore
      }
    },
		mounted() {
      this.getMypostlist('', '', true);
      // window.addEventListener('scroll', this.handleScroll, true);

			var data4Swipers = new Swiper('.data4-swiper', {
        observer: true,
        observeParents:true,
				navigation: {
					nextEl: '.data4-swiper-box .swiper-button-next',
					prevEl: '.data4-swiper-box .swiper-button-prev',
				},
      });
      var data5Swipers = new Swiper('.data5-swiper', {
        observer: true,
        observeParents:true,
				navigation: {
					nextEl: '.data5-swiper-box .swiper-button-next',
					prevEl: '.data5-swiper-box .swiper-button-prev',
				},
			});
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
		methods: {
      handleScroll() {
        // const a = this.$refs.lists.scrollHeight;
        // const b= this.$refs.lists.clientHeight;
        // const c = this.$refs.lists.scrollTop;
        const d = window.pageYOffset;


        const data0 = this.$refs.data0.clientHeight;
        const data1 = this.$refs.data1.clientHeight;

        console.log('handleScroll--d==', d);
        console.log('handleScroll--data0==', data0);
        console.log('handleScroll--data1==', data1);
        

        // console.log('handleScroll--a==', a);
        // console.log('handleScroll--b==', b);
        // console.log('handleScroll--c==', c);
        // console.log('handleScroll--d==', d);
        // console.log('handleScroll--e==', e);
        return;
        

        if (b + c >= a* 0.9) {
          if (this.isMoreLoad && !this.isLoading) {
            this.pageNum += 1;
            this.getMypostlist();
          } else {
            return;
          }
        }
      },
      scrollLoadMore(){
      // 防止多次加载
        if(this.loadingImg){
          return;
        }
        this.loadingImg = true;
        this.$http.get('url',{
              params:{
                  'pageNum': _this.definePageNum,
                  'pageSize': _this.definePageSize,
              }
          }).then((res) =>{
            if(res.data.code == 'success'){
              this.totals = res.data.data.total;
              if(this.totals - this.definePageNum*definePafeSize > 0){
                this.isMoreLoad = true;
              }else{
                this.isMoreLoad = false;
                this.loadLastText = true;
              }
              this.loadingImg = false;
            }
          })
      },
      async getMypostlist() {
        
				const payload = {
          type: 1,
					page: this.pageNum
				};
				const res = await casePage(payload);
        console.log('new--business--getMypostlist--res==', res);
        let list  = [];
        if (res.data.baseData.list.length) {
          res.data.baseData.list.forEach(d => {
            d.isShow && list.push(d);
          });
        }
        if (payload.page == 1) {
          this.pageData.data0.lists = list;
        } else {
          this.pageData.data0.lists = this.pageData.data0.lists.concat(list);
        }
        this.$set(this, 'pageData', this.pageData);
      },
      async init() {
        const res = await getAppInfo('key-info-case-bg-imgUrl1');
        this.pageData.banner = res.data.baseData.content;
        console.log('new--res==', res);

        this.casePage(1);
        // const lists = res1.list.filter(d => d.isShow);
        // this.pageData.data0.lists = lists || [];
        // console.log('new--res1==', res1);

        this.$set(this, 'pageData', this.pageData);
        console.log('new--this.pageData==', this.pageData);
      },
      async casePage(page) {
        console.log('casePage--page==', page);
        if (this.lastPage || this.isLoading) {
          return;
        }
        this.isLoading = true;
				const payload = {
          type: 1,
					page: page || this.pageNum + 1
        };
				const res = await casePage(payload);
        console.log('new--business--casePage--res==', res);
        const baseData = res.data.baseData;

        this.lastPage = baseData.lastPage;
        const list = baseData.list || [];

        if (baseData.firstPage) {
          this.pageData.data0.lists = list;
        } else {
          this.pageData.data0.lists = this.pageData.data0.lists.concat(list);
        }
        if (this.lastPage) {
          this.noMore = true;
        }
        this.$set(this, 'pageData', this.pageData);
        this.isLoading = false;
				// return res.data.baseData;
      },
      // openPage(url) {
      //   let cur_route = this.$route.path
      //   if (cur_route == url) {
      //     return;
      //   }
      //   this.$router.push(url);
      // },
      openPage(item) {
				if (!item && !item.id) {
					return;
        }
        let url = item.source == 2 ? item.newsUrl : `details/${item.id}`;

        let cur_route = this.$route.path
        if (cur_route == url) {
          return;
        }
        if (item.source == 2) {
          // window.open(url, '_blank');
          url = url.indexOf('https://') != 0 ? 'https://' + url : url;
          window.open(url);
        } else {
          window.location.href = url;
        }
			},
			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			changeServiceIndex(index) {
				this.serviceIndex = index;
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},

			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	}
</script>

<style scoped lang="scss">
@import '../common/css/new.scss';
</style>



// WEBPACK FOOTER //
// src/pages/newBusiness.vue